import axios from "axios";
import { toast } from "react-toastify";
import { server } from "../../server";

export const getAllCategoriesList =
  (pageNo, pageSize, searchParams) => async (dispatch) => {
    dispatch({ type: "GET_ALL_CATEGORIES_REQUEST" });
    try {
      const { data } = await axios.get(`${server}/category/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo,
          pageSize,
          deleted: false,
          searchParams,
        },
      });

      dispatch({
        type: "GET_ALL_CATEGORIES_SUCCESS",
        payload: {
          categoriesList: data?.data || [],
          count: data?.count || 0,
        },
      });
    } catch (e) {
      dispatch({ type: "GET_ALL_CATEGORIES_FAIL" });
      toast.error(e?.response?.data?.message || e?.message);
    }
  };

export const getAllCarouselImages =
  (pageNo, pageSize, searchParams) => async (dispatch) => {
    dispatch({ type: "GET_ALL_CAROUSELS_IMAGES_REQUEST" });
    try {
      const { data } = await axios.get(`${server}/carousel/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo,
          pageSize,
          deleted: false,
          searchParams,
        },
      });

      dispatch({
        type: "GET_ALL_CAROUSELS_IMAGES_SUCCESS",
        payload: { carouselsList: data?.data || [], count: data?.count || 0 },
      });
    } catch (e) {
      dispatch({ type: "GET_ALL_CAROUSELS_IMAGES_FAIL" });
      toast.error(e?.response?.data?.message || e?.message);
    }
  };

export const getAllTeamsList =
  (pageNo, pageSize, searchParams) => async (dispatch) => {
    dispatch({ type: "GET_ALL_TEAMS_REQUEST" });
    try {
      const { data } = await axios.get(`${server}/ourTeam/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo,
          pageSize,
          deleted: false,
          searchParams,
        },
      });

      dispatch({
        type: "GET_ALL_TEAMS_SUCCESS",
        payload: {
          teamsList: data?.data || [],
          count: data?.count || 0,
        },
      });
    } catch (e) {
      dispatch({ type: "GET_ALL_TEAMS_FAIL" });
      toast.error(e?.response?.data?.message || e?.message);
    }
  };

export const getAllTestimonials =
  (pageNo, pageSize, searchParams) => async (dispatch) => {
    dispatch({ type: "GET_ALL_TESTIMONIALS_REQUEST" });
    try {
      const { data } = await axios.get(`${server}/testimonial/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo,
          pageSize: 1000,
          deleted: false,
          searchParams,
        },
      });

      

      dispatch({
        type: "GET_ALL_TESTIMONIALS_SUCCESS",
        payload: {
          testimonialsList: data?.data || [],
          count: data?.count || 0,
        },
      });
    } catch (e) {
      dispatch({ type: "GET_ALL_TESTIMONIALS_FAIL" });
      toast.error(e?.response?.data?.message || e?.message);
    }
  };

export const getAllMissionsAndVisions =
  (pageNo, pageSize, searchParams) => async (dispatch) => {
    dispatch({ type: "GET_ALL_MISSION_AND_VISION_REQUEST" });
    try {
      const { data } = await axios.get(`${server}/missionAndVision/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo,
          pageSize,
          deleted: false,
          searchParams,
        },
      });

      dispatch({
        type: "GET_ALL_MISSION_AND_VISION_SUCCESS",
        payload: {
          missionAndVisionsList: data?.data || [],
          count: data?.count || 0,
        },
      });
    } catch (e) {
      dispatch({ type: "GET_ALL_MISSION_AND_VISION_FAIL" });
      toast.error(e?.response?.data?.message || e?.message);
    }
  };

export const getAllEvents =
  (pageNo, pageSize, searchParams) => async (dispatch) => {
    dispatch({ type: "GET_ALL_EVENTS_REQUEST" });
    try {
      const { data } = await axios.get(`${server}/event/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo,
          pageSize,
          deleted: false,
          searchParams,
        },
      });

      dispatch({
        type: "GET_ALL_EVENTS_SUCCESS",
        payload: {
          eventsList: data?.data || [],
          count: data?.count || 0,
        },
      });
    } catch (e) {
      dispatch({ type: "GET_ALL_EVENTS_FAIL" });
      toast.error(e?.response?.data?.message || e?.message);
    }
  };

export const getOurStories =
  (pageNo, pageSize, searchParams) => async (dispatch) => {
    dispatch({ type: "GET_ALL_OUR_STORY_REQUEST" });
    try {
      const { data } = await axios.get(`${server}/ourStory/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo,
          pageSize,
          deleted: false,
          searchParams,
        },
      });

      dispatch({
        type: "GET_ALL_OUR_STORY_SUCCESS",
        payload: {
          ourStoriesList: data?.data || [],
          count: data?.count || 0,
        },
      });
    } catch (e) {
      dispatch({ type: "GET_ALL_OUR_STORY_FAIL" });
      toast.error(e?.response?.data?.message || e?.message);
    }
  };

export const getAllGalleryMedias =
  (pageNo, pageSize, searchParams) => async (dispatch) => {
    dispatch({ type: "GET_ALL_GALLERY_REQUEST" });
    try {
      const { data } = await axios.get(`${server}/gallery/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo,
          pageSize,
          deleted: false,
          searchParams,
        },
      });

      dispatch({
        type: "GET_ALL_GALLERY_SUCCESS",
        payload: {
          galleryList: data?.data || [],
          count: data?.count || 0,
        },
      });
    } catch (e) {
      dispatch({ type: "GET_ALL_GALLERY_FAIL" });
      toast.error(e?.response?.data?.message || e?.message);
    }
  };

export const getAllBookingRequests =
  (pageNo, pageSize, searchParams, status) => async (dispatch) => {
    dispatch({ type: "GET_ALL_BOOKINGS_REQUEST" });
    try {
      const { data } = await axios.get(`${server}/bookingRequest/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo,
          pageSize,
          deleted: false,
          searchParams,
          status,
        },
      });

      dispatch({
        type: "GET_ALL_BOOKINGS_SUCCESS",
        payload: {
          bookingRequestsList: data?.data || [],
          count: data?.count || 0,
        },
      });
    } catch (e) {
      dispatch({ type: "GET_ALL_BOOKINGS_FAIL" });
      toast.error(e?.response?.data?.message || e?.message);
    }
  };


export const getAllUsersList =
  (pageNo, pageSize, searchParams) => async (dispatch) => {
    dispatch({ type: "GET_ALL_USERS_REQUEST" });
    try {
      const { data } = await axios.get(`${server}/auth/getAllUsers`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo,
          pageSize,
          deleted: false,
          searchParams,
        },
      });

      dispatch({
        type: "GET_ALL_USERS_SUCCESS",
        payload: {
          usersList: data?.data || [],
          count: data?.count || 0,
        },
      });
    } catch (e) {
      dispatch({ type: "GET_ALL_USERS_FAIL" });
      toast.error(e?.response?.data?.message || e?.message);
    }
  };

export const getAllPricingsList =
  (pageNo, pageSize, searchParams, category) => async (dispatch) => {
    dispatch({ type: "GET_ALL_PRICINGS_REQUEST" });
    try {
      const { data } = await axios.get(`${server}/pricing/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo,
          pageSize,
          deleted: false,
          searchParams,
          category,
        },
      });

      dispatch({
        type: "GET_ALL_PRICINGS_SUCCESS",
        payload: {
          pricingsList: data?.data || [],
          pricingCategories: data?.pricingCategories || [],
          count: data?.count || 0,
        },
      });
    } catch (e) {
      dispatch({ type: "GET_ALL_PRICINGS_FAIL" });
      toast.error(e?.response?.data?.message || e?.message);
    }
  };


